<template>
  <div class="radio-group clearfix">
    <label
      class="radio"
      v-for="(item,index) in list"
      :key="item[bindValue]"
      :for="getRadioId(index)"
      @click="clickRadio(item)"
    >
      <input
        type="radio"
        :value="item[bindValue]"
        :id="getRadioId(index)"
        :name="radioName"
        :checked="item[bindValue] === radioValue"
      >
      <i></i>
      {{item[displayText]}}
    </label>
  </div>
</template>
<script>
export default {
  name: "radio-button-group",
  props: {
    list: {
      type: Array,
      required: true,
      default: []
    },
    name: {
      type: String,
      required: false
    },
    displayText: {
      type: String,
      required: false,
      default: "Name"
    },
    bindValue: {
      type: String,
      required: false,
      default: "Id"
    },
    value: {
      required: false
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      radioValue: "",
      radioName: "",
      radioIndex: 0
    };
  },
  watch: {
    value(newValue) {
      console.log("radioButtonGroup value change");
      this.radioValue = newValue ? newValue.toString() : "";
    }
  },
  created() {
    if (this.value) {
      this.radioValue = this.value.toString();
    }
    if (!this.name) {
      this.radioName = "radio_" + parseInt(Math.random()) * 1000000;
    } else {
      this.radioName = this.name;
    }
  },
  methods: {
    clickRadio(item) {
      this.radioValue = item[this.bindValue];
      this.$emit("change", this.radioValue);
    },
    getRadioId(index) {
      return this.radioName + index;
    }
  }
};
</script>
 
